/* eslint-disable import/first */
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

// Constants
import { ROUTES } from "../constants";

// MUI Icons (v4)
import HomeIcon from "@material-ui/icons/Home";
import TableIcon from "@material-ui/icons/Description";
import DownloadIcon from "@material-ui/icons/GetApp";
import MapPageIcon from "@material-ui/icons/Map";
import BarChartIcon from "@material-ui/icons/BarChart";
import AssessmentIcon from "@material-ui/icons/Assessment";

// Pages
import PublicMap from "../pages/publicMap";
import PrecipDailyAndCumulative from "../pages/precipitation/PrecipDailyAndCumulative";
import TimeSeriesComparison from "../pages/timeSeriesComparison/TimeSeriesComparison";
import QueryAndDownload from "../pages/queryAndDownload/QueryAndDownload";
import SitesSummaryTable from "../pages/siteSummaryTable/SitesSummaryTable";
import PublicMapIFrame from "../pages/publicMap/publicMapIFrame";
import PublicMapIFramePAP from "../pages/publicMap/publicMapIFramePAP";
import FieldDepthProfile from "../pages/fieldDepthProfile/FieldDepthProfile";
import ContinuousTemperatureProfile from "../pages/continuousTemperatureProfile/ContinuousTemperatureProfile";
import YearComparison from "../pages/yearComparison/YearComparison";
import PrfStatisticsTool from "../pages/prfStatisticsTool/PrfStatisticsTool";
import WaterQualityTrends from "../pages/waterQualityTrends/WaterQualityTrends";
import CorrelationGraph from "../pages/correlationGraph/CorrelationGraph";
import CcrInflowConcentrations from "../pages/ccrInflowConcentrations/CcrInflowConcentrations";
import NutrientRatios from "../pages/nutrientRatios/NutrientRatios";
import WqInflowComparison from "../pages/wqInflowComparison/WqInflowComparison";
import WqScorecard from "../pages/wqScorecard/WqScorecard";
import LandingPage from "../pages/home/LandingPage";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import {
  BubbleChart,
  Equalizer,
  MultilineChart,
  ShowChart,
  Timeline,
  VerticalSplit,
} from "@material-ui/icons";
import Accessibility from "../pages/pages/Accessibility";
import CcrInflowConcentrationsEmbed from "../pages/ccrInflowConcentrations/CcrInflowConcentrationsEmbed";
import WaterQualityTrendsEmbed from "../pages/waterQualityTrends/WaterQualityTrendsEmbed";
import FieldDepthProfileEmbed from "../pages/fieldDepthProfile/FieldDepthProfileEmbed";
import NutrientRatiosEmbed from "../pages/nutrientRatios/NutrientRatiosEmbed";
import WqInflowComparisonEmbed from "../pages/wqInflowComparison/WqInflowComparisonEmbed";
import YearComparisonEmbed from "../pages/yearComparison/YearComparisonEmbed";
import CorrelationGraphEmbed from "../pages/correlationGraph/CorrelationGraphEmbed";
import SeasonalMeanEmbed from "../pages/seasonalMean/SeasonalMeanEmbed";
import StreamflowData from "../pages/streamflowData/StreamflowData";
import StreamflowDataEmbed from "../pages/streamflowData/StreamflowDataEmbed";
import UpstreamDownstream from "../pages/upstreamDownstream/UpstreamDownstream";
import UpstreamDownstreamEmbed from "../pages/upstreamDownstream/UpstreamDownstreamEmbed";
import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import ClimateMonthly from "../pages/climateMonthly/ClimateMonthly";
import ClimateMonthlyEmbed from "../pages/climateMonthly/ClimateMonthlyEmbed";
import WbSunny from "@material-ui/icons/WbSunny";

// Home
const homeRoute = {
  id: "Home",
  path: ROUTES.HOME,
  icon: <HomeIcon />,
  component: LandingPage,
  children: null,
};
//<iframe allowfullscreen="" frameborder="0" height="100%" src="https://explore.ccbwqportal.org/water-quality-update/field-depth-profile?start_date=10%2F01%2F2024&end_date=09%2F30%2F2025&locationid=80&parameterid=29" style="border:0" width="100%"></iframe>

const annualReportRoutes = {
  id: "Annual Report Visualizations",
  children: [
    {
      // phos /concentrations?parameterGroup=28%2C47&start_date=10%2F01%2F2024&end_date=09%2F30%2F2025&locationIds=68%2C83
      // nitro /concentrations?parameterGroup=29%2C47&start_date=10%2F01%2F2024&end_date=09%2F30%2F2025&locationIds=68%2C83
      // tss /concentrations?parameterGroup=30&start_date=10%2F01%2F2024&end_date=09%2F30%2F2025&locationIds=68%2C83
      path: ROUTES.ANNUAL_REPORT_CONCENTRATIONS,
      name: "Watershed Water Quality",
      component: () => <CcrInflowConcentrationsEmbed />,
    },
    {
      // chlor /reservoir-water-quality-summary?parameterid=24&start_date=10%2F01%2F2024&end_date=09%2F30%2F2025&season=annual&locationIds=79%2C80%2C81
      // phos /reservoir-water-quality-summary?parameterid=28&start_date=10%2F01%2F2024&end_date=09%2F30%2F2025&season=annual&locationIds=79%2C80%2C81
      // nitro /reservoir-water-quality-summary?parameterid=29&start_date=10%2F01%2F2024&end_date=09%2F30%2F2025&season=annual&locationIds=79%2C80%2C81
      path: ROUTES.ANNUAL_REPORT_RESERVOIR_SUMMARY,
      name: "Reservoir Water Quality Summary",
      component: () => <WaterQualityTrendsEmbed />,
    },
    {
      // DO /reservoir-depth-profile?start_date=10%2F01%2F2024&end_date=09%2F30%2F2025&locationid=80&parameterid=3
      // total N /reservoir-depth-profile?start_date=10%2F01%2F2024&end_date=09%2F30%2F2025&locationid=80&parameterid=29
      path: ROUTES.ANNUAL_REPORT_DEPTH_PROFILE,
      name: "Reservoir Depth Profile",
      component: () => <FieldDepthProfileEmbed />,
    },
    {
      path: ROUTES.ANNUAL_REPORT_NUTRIENT_RATIOS,
      name: "Nutrient Ratios",
      component: () => <NutrientRatiosEmbed />,
    },
    {
      path: ROUTES.ANNUAL_REPORT_INFLOW_COMPARISONS,
      name: "Reservoir Inflow Comparisons",
      component: () => <WqInflowComparisonEmbed />,
    },
    {
      path: ROUTES.ANNUAL_REPORT_YEAR_COMPARISON,
      name: "Year Comparison",
      component: () => <YearComparisonEmbed />,
    },
    {
      path: ROUTES.ANNUAL_REPORT_CORRELATION_GRAPH,
      name: "Correlation Graph",
      component: () => <CorrelationGraphEmbed />,
    },
    {
      path: ROUTES.ANNUAL_REPORT_SEASONAL_MEAN,
      name: "Seasonal Mean",
      component: () => <SeasonalMeanEmbed />,
    },
    {
      path: ROUTES.ANNUAL_REPORT_STREAMFLOW_DATA,
      name: "Streamflow Data",
      component: () => <StreamflowDataEmbed />,
    },
    {
      // one reach per iframe, e.g. ?parameterid=28&reaches=106&year=2025
      path: ROUTES.ANNUAL_REPORT_UPSTREAM_DOWNSTREAM,
      name: "Upstream to Downstream",
      component: () => <UpstreamDownstreamEmbed />,
    },
    {
      path: ROUTES.ANNUAL_REPORT_CLIMATE_MONTHLY,
      name: "Monthly Climate Comparison",
      component: () => <ClimateMonthlyEmbed />,
    },
  ],
};

// Explore
const timeSeriesComparisonRoute = {
  header: "Explore",
  id: "Time Series Comparison",
  icon: <MultilineChart />,
  path: ROUTES.TIME_SERIES_COMPARISON,
  component: TimeSeriesComparison,
};

const streamflowDataRoute = {
  id: "Streamflow Data",
  icon: <ShowChart />,
  path: ROUTES.STREAMFLOW_DATA,
  component: StreamflowData,
};

const precipitationRoute = {
  id: "Precipitation in the Basin",
  icon: <Timeline />,
  path: ROUTES.PRECIPITATION,
  component: PrecipDailyAndCumulative,
};

const climateMonthlyRoute = {
  id: "Monthly Climate Comparison",
  icon: <WbSunny />,
  path: ROUTES.CLIMATE_MONTHLY,
  component: ClimateMonthly,
};

// const prfPerformanceRoute = {
//   id: "PRF Performance",
//   icon: <PerformanceIcon />,
//   path: ROUTES.PRF_PERFORMANCE,
//   component: () => (
//     <ComingSoon
//       externalLink={{
//         url: "https://ccbwqportal.org/prf-performance",
//         text: "our current Performance Tool",
//       }}
//     />
//   ),
// };

const prfStatisticsToolRoute = {
  header: "Tools",
  id: "PRF Statistics Tool",
  icon: <VerticalSplit />,
  path: ROUTES.PRF_STATISTICS_TOOL,
  component: PrfStatisticsTool,
};

const yearComparisonGraphRoute = {
  id: "Year Comparison Graph",
  icon: <Equalizer />,
  path: ROUTES.YEAR_COMPARISON_GRAPH,
  component: YearComparison,
};

const correlationGraphRoute = {
  id: "Correlation Graph",
  icon: <BubbleChart />,
  path: ROUTES.CORRELATION_GRAPH,
  component: CorrelationGraph,
};

const upstreamDownstreamRoute = {
  id: "Upstream to Downstream",
  icon: <TrendingDownIcon />,
  path: ROUTES.UPSTREAM_DOWNSTREAM,
  component: UpstreamDownstream,
};

// Water Quality Update
const waterQualityParameterViewerRoute = {
  header: "Water Quality Update",
  id: "Reservoir Water Quality Summary",
  icon: <BubbleChart />,
  path: ROUTES.WATER_QUALITY_PARAMETER_VIEWER,
  component: WaterQualityTrends,
};

const ccrInflowConcentrationsRoute = {
  id: "Watershed Water Quality",
  icon: <BubbleChart />,
  path: ROUTES.CCR_INFLOW_CONCENTRATIONS,
  component: CcrInflowConcentrations,
};

const wqInflowComparisonRoute = {
  id: "Reservoir Inflow Comparisons",
  icon: <Equalizer />,
  path: ROUTES.WQ_INFLOW_COMPARISON,
  component: WqInflowComparison,
};

const fieldDepthProfileRoute = {
  id: "Reservoir Depth Profile",
  icon: <VerticalSplit />,
  path: ROUTES.FIELD_DEPTH_PROFILE,
  component: FieldDepthProfile,
};

const continuousTemperatureProfileRoute = {
  id: "Continuous Temperature Profile (Sonde)",
  icon: <Timeline />,
  path: ROUTES.CONTINUOUS_TEMPERATURE_PROFILE,
  component: ContinuousTemperatureProfile,
};

const nutrientRatiosRoute = {
  id: "Nutrient Ratios",
  icon: <ShowChart />,
  path: ROUTES.NUTRIENT_RATIOS,
  component: NutrientRatios,
};

const wqScorecardRoute = {
  id: "Water Quality Scorecard",
  icon: <AssessmentIcon />,
  path: ROUTES.WQ_SCORECARD,
  component: WqScorecard,
};

// Tools
/**
 * Both map entries render the same page, the water quality one carries the
 * mode in its link. `isActive` keeps only the matching entry highlighted
 */
const isWaterQualityView = (location) => location.search.includes("mode=wq");

const mapRoute = {
  id: "Map Explorer",
  icon: <MapPageIcon />,
  path: ROUTES.MAP,
  component: PublicMap,
  isActive: (match, location) => !!match && !isWaterQualityView(location),
};

// nav only, the route above renders it
const waterQualityMapRoute = {
  id: "Water Quality Map",
  icon: <BarChartIcon />,
  path: ROUTES.MAP_WATER_QUALITY,
  isActive: (match, location) => !!match && isWaterQualityView(location),
};

const downloadRoute = {
  id: "Query & Download",
  icon: <DownloadIcon />,
  path: ROUTES.DOWNLOAD,
  component: QueryAndDownload,
};

const siteSummaryTableRoute = {
  id: "Site Summary Table",
  icon: <TableIcon />,
  path: ROUTES.SITE_SUMMARY_TABLE,
  component: SitesSummaryTable,
};

const externalImportLinkRoute = {
  id: "Import Data",
  link: "external",
  icon: <OpenInNewIcon />,
  path: ROUTES.IMPORT,
};

const externalFloodAlertLinkRoute = {
  id: "MHFD Flood Alert",
  link: "external",
  icon: <OpenInNewIcon />,
  path: ROUTES.MHFD_FLOOD_ALERT,
};

const externalReservoirElevationLinkRoute = {
  id: "Reservoir Elevation",
  link: "external",
  icon: <OpenInNewIcon />,
  path: ROUTES.RESERVOIR_ELEVATION,
};

const accessibilityRoute = {
  id: "Accessibility",
  icon: <OpenInNewIcon />,
  path: ROUTES.ACCESSIBILITY,
  component: Accessibility,
};

// Logout
const Logout = () => {
  const { logout } = useAuth0();
  React.useEffect(() => {
    logout();
  }, [logout]);
  return null;
};

const logoutRoute = {
  id: "Logout",
  path: ROUTES.LOGOUT,
  component: Logout,
};

// IFrames
const publicMapIFrame = {
  id: "Public Map iFrame",
  icon: <DownloadIcon />,
  path: ROUTES.MAP_IFRAME,
  component: PublicMapIFrame,
};

const publicMapIFramePAP = {
  id: "Public Map iFrame PAP",
  icon: <DownloadIcon />,
  path: ROUTES.PAP_MAP_IFRAME,
  component: PublicMapIFramePAP,
};

// Exports
export const dashboardLayoutRoutes = [
  // homeRoute,
  timeSeriesComparisonRoute,
  streamflowDataRoute,
  precipitationRoute,
  // prfPerformanceRoute,
  prfStatisticsToolRoute,
  yearComparisonGraphRoute,
  correlationGraphRoute,
  waterQualityParameterViewerRoute,
  ccrInflowConcentrationsRoute,
  wqInflowComparisonRoute,
  fieldDepthProfileRoute,
  continuousTemperatureProfileRoute,
  nutrientRatiosRoute,
  wqScorecardRoute,
  downloadRoute,
  siteSummaryTableRoute,
  externalFloodAlertLinkRoute,
  externalReservoirElevationLinkRoute,
  accessibilityRoute,
  logoutRoute,
  upstreamDownstreamRoute,
  climateMonthlyRoute,
];

export const dashboardMaxContentLayoutRoutes = [mapRoute, homeRoute];

export const authLayoutRoutes = [];

export const presentationLayoutRoutes = [
  publicMapIFrame,
  publicMapIFramePAP,
  annualReportRoutes,
];

export const fullscreenMapRoutes = [];

export const sidebarRoutes = [
  homeRoute,
  mapRoute,
  waterQualityMapRoute,
  waterQualityParameterViewerRoute,
  wqScorecardRoute,
  fieldDepthProfileRoute,
  continuousTemperatureProfileRoute,
  nutrientRatiosRoute,
  wqInflowComparisonRoute,
  ccrInflowConcentrationsRoute,
  timeSeriesComparisonRoute,
  yearComparisonGraphRoute,
  correlationGraphRoute,
  precipitationRoute,
  climateMonthlyRoute,
  streamflowDataRoute,
  upstreamDownstreamRoute,
  // prfPerformanceRoute,
  prfStatisticsToolRoute,
  downloadRoute,
  siteSummaryTableRoute,
  externalImportLinkRoute,
  externalFloodAlertLinkRoute,
  externalReservoirElevationLinkRoute,
];
